import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, resolveImg } from "@/lib/api";

export const ImageUploader = ({ value, onChange, label, testid, aspect = "aspect-square" }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Please select an image file.");
      return;
    }
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error("Upload failed. Try again.");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {label && <p className="font-body text-sm font-medium text-charcoal mb-2">{label}</p>}
      <div
        className={`relative ${aspect} w-full rounded-2xl overflow-hidden bg-beige border border-gold/30 group`}
      >
        {value ? (
          <img src={resolveImg(value)} alt={label || "preview"} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-charcoal/40 text-sm">
            No photo
          </div>
        )}
        <button
          type="button"
          data-testid={`${testid}-upload-btn`}
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 bg-charcoal/0 group-hover:bg-charcoal/50 text-transparent group-hover:text-cream transition-all duration-300"
        >
          {uploading ? (
            <Loader2 className="animate-spin text-cream" size={26} />
          ) : (
            <>
              <Upload size={22} />
              <span className="font-body text-xs font-semibold">Replace photo</span>
            </>
          )}
        </button>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        data-testid={`${testid}-file-input`}
        onChange={handleFile}
        className="hidden"
      />
    </div>
  );
};
